<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">Manage User Interest</h1>
    </div>
  </div>
  <button
    type="button"
    class="flex flex-row justify-between btn custom-btn-primary-adminui gap-1"
    (click)="onOpenModal()"
    tabindex="0"
    aria-label="Add New User interest"
  >
    <div>
      <img
        class="add-icon"
        src="../../../../assets/icons/add-icon.svg"
        alt="Add"
      />
    </div>
    <div>
      <span>Add New User interest</span>
    </div>
  </button>
</div>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Sessional user interest tag</span>
    </div>
  </div>
</ng-template>
<nz-spin nzTip="Loading..." [nzSpinning]="masterDataLoading">
  <nz-table
    #basicTable
    [nzData]="sessionalTags"
    [nzTitle]="tableHead"
    [nzScroll]="{ y: '500px' }"
    class="mt-5"
    [nzShowPagination]="true"
    nzFrontPagination="false"
    [nzBordered]="true"
    [nzShowSizeChanger]="true"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th>Name</th>
        <th>Visibility</th>
        <th>Added by</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of basicTable.data"
        [ngClass]="{
          'bg-red-400 text-red-800 hover:bg-red-100': data.active === false
        }"
      >
        <td>{{ data.data }}</td>
        <td>{{ data.active }}</td>
        <td>{{ data.addedBy }}</td>
        <td>
          <div class="flex items-center justify-evenly">
            <span nz-tooltip nzTooltipTitle="View Circle">
              <button
                (click)="onEditClick(data.m_id)"
                nz-button
                nzType="primary"
                nzShape="circle"
              >
                <span nz-icon nzType="eye" nzTheme="outline"></span>
              </button>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>

<nz-modal
  [(nzVisible)]="isModalVisible"
  nzTitle="Add User Interest Tag"
  [nzFooter]="null"
  (nzOnCancel)="isModalVisible = false; previewImageUrl = undefined"
  [nzContent]="modalContent"
>
  <ng-template #modalContent>
    <nz-spin nzTip="Submitting..." [nzSpinning]="loading">
      <form [formGroup]="tagForm" (ngSubmit)="onSubmit()" class="space-y-4">
        <div class="flex items-center gap-2">
          <label>Active</label>
          <nz-switch
            formControlName="active"
            (ngModelChange)="onSwitchChange($event)"
          ></nz-switch>
        </div>

        <!-- Name Input -->
        <div class="flex flex-col">
          <label class="mb-1">Name</label>
          <input nz-input formControlName="tag" placeholder="Enter tag" />
        </div>

        <!-- Image Upload -->
        <div class="flex flex-col mb-4">
          <label class="mb-1" for="imageUpload">Upload Image</label>
          <img
            *ngIf="existingImageUrl || previewImageUrl"
            class="w-14 h-14 object-cover"
            [src]="previewImageUrl || existingImageUrl"
            alt="vertical-image"
          />
          <input
            type="file"
            formControlName="image"
            id="imageUpload"
            (change)="uploadImages($event)"
            accept="image/*"
            class="border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <!-- Partners Select -->
        <div class="flex flex-col">
          <label class="mb-1">Partners</label>
          <nz-select
            formControlName="partnerIds"
            nzMode="multiple"
            nzPlaceHolder="Select partners"
            [nzOptions]="partnerOptions"
            class="w-full"
          ></nz-select>
        </div>

        <!-- Experts Select -->
        <div class="flex flex-col">
          <label class="mb-1">Experts</label>
          <nz-select
            formControlName="expertIds"
            nzMode="multiple"
            nzPlaceHolder="Select experts"
            [nzOptions]="expertOptions"
            class="w-full"
          ></nz-select>
        </div>

        <div class="flex justify-end gap-2 pt-4">
          <button nz-button nzType="default" (click)="isModalVisible = false">
            Cancel
          </button>
          <button nz-button nzType="primary" [disabled]="tagForm.invalid">
            Submit
          </button>
        </div>
      </form>
    </nz-spin>
  </ng-template>
</nz-modal>
